// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__wnL1v","content":"styles_content__3zXIZ","checkbox":"styles_checkbox__35I03","checkboxLabel":"styles_checkboxLabel__2Fe73"};